import resume from './resume'
import referralCode from './referral-code'
import pushOpen from './push-open'
import deeplink from './deeplink'
import mobileAppInstalled from './mobile-app-installed'

// list of all persistent handlers
export default [
  resume,
  referralCode,
  pushOpen,
  deeplink,
  mobileAppInstalled,
]
